export default __webpack_public_path__ + "static/media/mini-1.061a319e.jpg";